import { render, staticRenderFns } from "./add-or-edit.vue?vue&type=template&id=62ccde38&"
import script from "./add-or-edit.vue?vue&type=script&lang=js&"
export * from "./add-or-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports